/**
 * @generated SignedSource<<1a8fc8327bbc16797934fde2f0d46ca7>>
 * @relayHash 8a31aae7d3b8c9fde55af400f49e8a24
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 51765b6bf2502b4d7d3de6aecb1717c47c8279e2b5b8bd7c763a11acfd774f5d

import type { ConcreteRequest } from 'relay-runtime';
export type HelpCenterMediaConfigOperationType = "BANNER_UPLOAD" | "LOGO_UPLOAD" | "READ" | "%future added value";
export type HelpCenterNavigationBarBorderType = "ALL_BORDER" | "BOTTOM_BORDER" | "NO_BORDER" | "%future added value";
export type HelpCenterNavigationBarPositionType = "FIXED" | "FLOATING" | "%future added value";
export type HelpCenterType = "ADVANCED" | "BASIC" | "CUSTOMER_SERVICE" | "HELP_HUB" | "UNIFIED" | "%future added value";
export type hubQuery$variables = {
  cloudId: string;
  hubAri: string;
  includeCustomPageParents?: boolean | null;
  isDraft?: boolean | null;
  operationType?: HelpCenterMediaConfigOperationType | null;
  pageAri: string;
  rovoConfigFromKosh?: boolean | null;
};
export type hubQuery$data = {
  readonly helpCenter: {
    readonly helpCenterById: {
      readonly __typename: "HelpCenter";
      readonly helpCenterBranding: {
        readonly navigationBar: {
          readonly backgroundColor: string | null;
          readonly borderColor: string | null;
          readonly borderType: HelpCenterNavigationBarBorderType | null;
          readonly cornerRadius: number | null;
          readonly padding: boolean | null;
          readonly positionType: HelpCenterNavigationBarPositionType | null;
          readonly textColor: string | null;
        } | null;
      } | null;
      readonly name: {
        readonly default: string;
      } | null;
      readonly pages: ReadonlyArray<{
        readonly id: string;
        readonly name: {
          readonly default: string;
        } | null;
        readonly pageLayout: {
          readonly layoutAdf: {
            readonly content: {
              readonly edges: ReadonlyArray<{
                readonly node: {
                  readonly content: string | null;
                } | null;
              } | null> | null;
            } | null;
          } | null;
        } | null;
        readonly parents?: ReadonlyArray<{
          readonly name: string;
        }> | null;
        readonly rovoConfig?: {
          readonly agentId: string | null;
          readonly isCustomAgentsAvailable: boolean | null;
          readonly isRovoEnabled: boolean | null;
          readonly widgetContainerAri: string | null;
        } | null;
      } | null> | null;
      readonly type: HelpCenterType | null;
    } | {
      readonly __typename: "QueryError";
      readonly message: string | null;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null;
    readonly pageMediaConfig: {
      readonly asapIssuer: string;
      readonly mediaCollectionName: string;
      readonly mediaToken: string;
      readonly mediaUrl: string;
    };
  } | null;
};
export type hubQuery = {
  response: hubQuery$data;
  variables: hubQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hubAri"
},
v2 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeCustomPageParents"
},
v3 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isDraft"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "operationType"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pageAri"
},
v6 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "rovoConfigFromKosh"
},
v7 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v8 = [
  {
    "kind": "Variable",
    "name": "ari",
    "variableName": "pageAri"
  },
  {
    "kind": "Variable",
    "name": "isDraft",
    "variableName": "isDraft"
  },
  {
    "kind": "Variable",
    "name": "operationType",
    "variableName": "operationType"
  }
],
v9 = {
  "kind": "ScalarField",
  "name": "asapIssuer"
},
v10 = {
  "kind": "ScalarField",
  "name": "mediaCollectionName"
},
v11 = {
  "kind": "ScalarField",
  "name": "mediaToken"
},
v12 = {
  "kind": "ScalarField",
  "name": "mediaUrl"
},
v13 = [
  {
    "kind": "Variable",
    "name": "helpCenterAri",
    "variableName": "hubAri"
  }
],
v14 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v15 = {
  "kind": "ScalarField",
  "name": "type"
},
v16 = [
  {
    "kind": "ScalarField",
    "name": "default"
  }
],
v17 = {
  "concreteType": "HelpCenterName",
  "kind": "LinkedField",
  "name": "name",
  "plural": false,
  "selections": (v16/*: any*/)
},
v18 = {
  "concreteType": "HelpCenterBranding",
  "kind": "LinkedField",
  "name": "helpCenterBranding",
  "plural": false,
  "selections": [
    {
      "concreteType": "HelpCenterNavigationBar",
      "kind": "LinkedField",
      "name": "navigationBar",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "backgroundColor"
        },
        {
          "kind": "ScalarField",
          "name": "borderColor"
        },
        {
          "kind": "ScalarField",
          "name": "borderType"
        },
        {
          "kind": "ScalarField",
          "name": "cornerRadius"
        },
        {
          "kind": "ScalarField",
          "name": "padding"
        },
        {
          "kind": "ScalarField",
          "name": "positionType"
        },
        {
          "kind": "ScalarField",
          "name": "textColor"
        }
      ]
    }
  ]
},
v19 = [
  {
    "fields": [
      {
        "items": [
          {
            "kind": "Variable",
            "name": "ids.0",
            "variableName": "pageAri"
          }
        ],
        "kind": "ListValue",
        "name": "ids"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  }
],
v20 = {
  "kind": "ScalarField",
  "name": "id"
},
v21 = {
  "concreteType": "HelpCenterPageName",
  "kind": "LinkedField",
  "name": "name",
  "plural": false,
  "selections": (v16/*: any*/)
},
v22 = {
  "kind": "ScalarField",
  "name": "name"
},
v23 = {
  "condition": "rovoConfigFromKosh",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "concreteType": "HelpCenterPageRovoConfig",
      "kind": "LinkedField",
      "name": "rovoConfig",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isCustomAgentsAvailable"
        },
        {
          "kind": "ScalarField",
          "name": "isRovoEnabled"
        },
        {
          "kind": "ScalarField",
          "name": "agentId"
        },
        {
          "kind": "ScalarField",
          "name": "widgetContainerAri"
        }
      ]
    }
  ]
},
v24 = {
  "concreteType": "HelpCenterPageLayout",
  "kind": "LinkedField",
  "name": "pageLayout",
  "plural": false,
  "selections": [
    {
      "concreteType": "HelpCenterLayoutAdf",
      "kind": "LinkedField",
      "name": "layoutAdf",
      "plural": false,
      "selections": [
        {
          "concreteType": "HelpCenterLayoutAdfContentConnection",
          "kind": "LinkedField",
          "name": "content",
          "plural": false,
          "selections": [
            {
              "concreteType": "HelpCenterLayoutAdfContentEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "concreteType": "HelpCenterLayoutAdfContent",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "content"
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
},
v25 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "message"
    }
  ],
  "type": "QueryError"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "name": "hubQuery",
    "selections": [
      {
        "args": (v7/*: any*/),
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "alias": "pageMediaConfig",
              "args": (v8/*: any*/),
              "concreteType": "HelpCenterMediaConfig",
              "kind": "LinkedField",
              "name": "hubMediaConfig",
              "plural": false,
              "selections": [
                {
                  "kind": "RequiredField",
                  "field": (v9/*: any*/),
                  "action": "THROW"
                },
                {
                  "kind": "RequiredField",
                  "field": (v10/*: any*/),
                  "action": "THROW"
                },
                {
                  "kind": "RequiredField",
                  "field": (v11/*: any*/),
                  "action": "THROW"
                },
                {
                  "kind": "RequiredField",
                  "field": (v12/*: any*/),
                  "action": "THROW"
                }
              ]
            },
            "action": "THROW"
          },
          {
            "args": (v13/*: any*/),
            "kind": "LinkedField",
            "name": "helpCenterById",
            "plural": false,
            "selections": [
              (v14/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v15/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  {
                    "args": (v19/*: any*/),
                    "concreteType": "HelpCenterPage",
                    "kind": "LinkedField",
                    "name": "pages",
                    "plural": true,
                    "selections": [
                      (v20/*: any*/),
                      (v21/*: any*/),
                      {
                        "condition": "includeCustomPageParents",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "concreteType": "HelpCenterPageParentReference",
                            "kind": "LinkedField",
                            "name": "parents",
                            "plural": true,
                            "selections": [
                              (v22/*: any*/)
                            ]
                          }
                        ]
                      },
                      (v23/*: any*/),
                      (v24/*: any*/)
                    ]
                  }
                ],
                "type": "HelpCenter"
              },
              (v25/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v5/*: any*/),
      (v4/*: any*/),
      (v6/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "hubQuery",
    "selections": [
      {
        "args": (v7/*: any*/),
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "alias": "pageMediaConfig",
            "args": (v8/*: any*/),
            "concreteType": "HelpCenterMediaConfig",
            "kind": "LinkedField",
            "name": "hubMediaConfig",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/)
            ]
          },
          {
            "args": (v13/*: any*/),
            "kind": "LinkedField",
            "name": "helpCenterById",
            "plural": false,
            "selections": [
              (v14/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v15/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  {
                    "args": (v19/*: any*/),
                    "concreteType": "HelpCenterPage",
                    "kind": "LinkedField",
                    "name": "pages",
                    "plural": true,
                    "selections": [
                      (v20/*: any*/),
                      (v21/*: any*/),
                      {
                        "condition": "includeCustomPageParents",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "concreteType": "HelpCenterPageParentReference",
                            "kind": "LinkedField",
                            "name": "parents",
                            "plural": true,
                            "selections": [
                              (v22/*: any*/),
                              (v20/*: any*/)
                            ]
                          }
                        ]
                      },
                      (v23/*: any*/),
                      (v24/*: any*/)
                    ]
                  }
                ],
                "type": "HelpCenter"
              },
              (v25/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v20/*: any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "51765b6bf2502b4d7d3de6aecb1717c47c8279e2b5b8bd7c763a11acfd774f5d",
    "metadata": {},
    "name": "hubQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "c16441ee88faaf83200addc773fa4c96";

export default node;
